import styled from '@emotion/styled';
import { Box, Text } from '@mantine/core';

import { fontSize, mediaQueryMobile, mediaQueryTablet } from '~/styles/mixins';

import bannerImg from '~/assets/images/home/banner.png';
import ChevronRightIconComponent from '~/assets/icons/chevron-right.svg';

export const Root = styled(Box)``;

const Flex = styled(Box)`
  display: flex;
`;

export const Section = styled(Box)`
  width: 100%;
  background-color: ${({ bgColor }) => bgColor || '#fff'};
`;

export const Container = styled(Box)`
  padding: 0 24px;
  width: 100%;
  max-width: 1272px;
  margin: 0 auto;
  ${mediaQueryTablet} {
    padding: 0 64px;
  }
  ${mediaQueryMobile} {
    padding: 0 20px;
  }
`;

export const HeroFlexContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  ${mediaQueryTablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TextWrapper = styled(Flex)`
  flex: 0 auto;
  flex-direction: column;
  width: 50%;
  min-width: 600px;
  ${mediaQueryTablet} {
    width: 100%;
    min-width: 0;
  }
`;

export const HeroTextWrapper = styled(TextWrapper)`
  padding: 200px 0 120px;
  margin-right: 24px;
  ${mediaQueryTablet} {
    padding: 40px 0 0;
  }
`;

export const HeroLottieWrapper = styled(Box)`
  max-width: 708px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const ScaleHeroLottieContainer = styled(HeroLottieWrapper)`
  ${mediaQueryMobile} {
    transform: scale(1.5);
  }
`;

export const HeroBtnWrapper = styled(Flex)`
  margin-top: 32px;
  gap: 16px;
  ${mediaQueryMobile} {
    flex-direction: column;
    align-items: center;
    > * {
      width: 100%;
    }
  }
`;

export const PrimaryButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #222;
  min-width: 259px;
  height: 56px;
  border-radius: 28px;
  padding: 16px 28px 16px 32px;
  font-size: 18px;
  font-weight: 600;
  line-height: 130%;
  letter-spacing: -0.01em;
  color: #fff;
  border: none;
  cursor: pointer;
  font-family: ${(p) => p.theme.other.fonts.body} !important;
  > svg {
    margin-left: 8px;
  }
  &:hover {
    background-color: #222;
  }
  ${mediaQueryMobile} {
    height: 48px;
  }
`;
PrimaryButton.defaultProps = {
  variant: 'filled',
  radius: 'xl',
  size: 'xl',
};

export const SecondaryBtn = styled(PrimaryButton)`
  background: #ffffff;
  &:hover {
    background: #bebebe;
  }
`;

export const OutlinedBtn = styled(PrimaryButton)`
  background: #ffffff;
  color: #222222;
  border: 1px solid #dddddd;
  &:hover {
    background: #f0f0f0;
  }
`;

export const CompaniesSection = styled(Section)`
  padding: 40px 0 48px;
  background-color: #222222;
  box-shadow: 0px 4px 40px -8px rgba(56, 25, 0, 0.06), 0px 4px 40px rgba(56, 25, 0, 0.04);
  ${mediaQueryMobile} {
    padding: 24px 0 12px;
  }
`;

export const TitleBorder = styled(Box)`
  flex: 1;
  height: 1px;
  width: 100%;
  background-color: #626262;
  margin-left: 16px;
  ${mediaQueryMobile} {
    display: none;
  }
`;

export const CompaniesLogoList = styled(Flex)`
  justify-content: space-between;
  margin: 4px -6px 0;
  ${mediaQueryTablet} {
    flex-wrap: wrap;
  }
`;

export const CompaniesLogoItem = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 6px;
  > img {
    max-height: 34px;
    ${mediaQueryMobile} {
      max-height: 22px;
    }
  }
  ${mediaQueryTablet} {
    width: 33%;
  }
`;

export const CherryPickSection = styled(Section)`
  display: flex;
  align-items: center;
  position: relative;
  padding: 120px 0;
  min-height: 658px;
  background: #f3f9ff;
  ${mediaQueryTablet} {
    height: auto;
    min-height: 720px;
    align-items: flex-start;
  }
  ${mediaQueryMobile} {
    padding: 40px 0;
  }
`;

export const TextWrapperLg = styled(TextWrapper)`
  min-width: 712px;
  ${mediaQueryTablet} {
    min-width: 0px;
  }
`;

export const CherryPickLottie = styled(Box)`
  width: 40%;
  max-width: 570px;
  position: absolute;
  margin-bottom: -7px;
  left: auto;
  top: auto;
  right: 0;
  bottom: 0;
  height: auto;
  ${mediaQueryTablet} {
    width: 90%;
    max-width: 423px;
    bottom: 8px;
  }
`;

export const QualityPointsSection = styled(Section)`
  padding: 120px 0;
  ${mediaQueryMobile} {
    padding: 40px 0;
  }
`;

export const QualityPointsContainer = styled(Flex)`
  ${mediaQueryTablet} {
    flex-direction: column;
  }
`;

export const PointsLinkContainer = styled(Flex)`
  margin-top: 24px;
  padding: 20px 0 12px;
  border-top: 1px solid #efefef;
  color: #0c7beb;
  align-items: center;
  > svg {
    margin-left: 4px;
  }
  ${mediaQueryMobile} {
    padding: 16px 0;
  }
`;

export const NavLink = styled(Text)`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  ${fontSize(16)};
  line-height: 125%;
  letter-spacing: -0.01em;
  color: #0c7beb;
  margin: 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  ${mediaQueryMobile} {
    ${fontSize(14)};
  }
`;
NavLink.defaultProps = { component: 'a' };

const PointsLottieWrapper = styled(Box)`
  width: 50%;
  max-width: 496px;
  ${mediaQueryTablet} {
    width: 100%;
  }
`;

export const PointsLottieLeft = styled(PointsLottieWrapper)`
  margin-left: 24px;
  ${mediaQueryTablet} {
    margin: 8px auto;
  }
`;

export const PointsLottieRight = styled(PointsLottieWrapper)`
  margin-right: 24px;
  ${mediaQueryTablet} {
    margin: 8px auto;
    order: 2;
  }
`;

export const TestimonialsSection = styled(Section)`
  padding: 120px 0;
  background-color: #fafafa;
  ${mediaQueryMobile} {
    padding: 40px 0;
  }
`;

export const TestimonialSliderContainer = styled(Box)`
  margin: 40px auto 0;
  position: relative;
  ${mediaQueryMobile} {
    margin-top: 24px;
  }
`;

export const ChevronRightIcon = styled(ChevronRightIconComponent)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: #ffffff;
`;
export const SliderArrowBtn = styled(Flex)`
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #222222;
  cursor: pointer;
  ${mediaQueryMobile} {
    width: 32px;
    height: 32px;
  }
`;

export const SliderArrowBtnLeft = styled(SliderArrowBtn)`
  left: -20px;
  ${ChevronRightIcon} {
    transform: rotate(180deg);
  }
  ${mediaQueryMobile} {
    left: -16px;
  }
`;
export const SliderArrowBtnRight = styled(SliderArrowBtn)`
  right: -20px;
  ${mediaQueryMobile} {
    right: -16px;
  }
`;

export const SliderDotsContainer = styled(Box)`
  padding: 0px 32px 48px;
  > ul {
    margin: 0;
    > li.slick-active {
      width: 56px;
      > button {
        width: 56px;
        background: #ffffff;
      }
    }
    > li {
      width: 32px;
      height: 8px;
      margin: 0 5px;
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 32px;
      > button {
        width: 32px;
        height: 8px;
        padding: 0;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 32px;
        &:before {
          content: '';
        }
      }
    }
  }
`;

export const HowSection = styled(Section)`
  padding: 120px 0 202px;
  ${mediaQueryTablet} {
    padding-bottom: 64px;
  }
  ${mediaQueryMobile} {
    padding: 40px 0 0;
  }
`;

export const HowCardsContainer = styled(Flex)`
  margin: 20px -12px 0;
  ${mediaQueryTablet} {
    flex-direction: column;
    margin: 20px 0;
  }
`;

export const HowCardsItem = styled(Box)`
  width: 33%;
  padding: 12px;
  ${mediaQueryTablet} {
    width: 100%;
    padding: 12px 0 88px;
  }
`;

export const BannerSection = styled(Section)`
  padding: 128px 0;
  background-color: #fafafa;
  ${mediaQueryMobile} {
    padding: 70px 0 114px;
  }
`;

export const BannerContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 20px 74px;
  border-radius: 8px;
  position: relative;
  background-color: #222222;
  background-image: url('${bannerImg}');
  background-repeat: no-repeat;
  background-position: -100px -250px;
  background-size: 305px;
  ${mediaQueryMobile} {
    padding-bottom: 54px;
  }
`;

export const BannerContent = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;

export const BannerImgContainer = styled(Box)`
  position: absolute;
  top: -41px;
  > img {
    height: 82px;
  }

  ${mediaQueryMobile} {
    top: -30px;
    > img {
      height: 60px;
    }
  }
`;

export const FaqSection = styled(Section)`
  padding: 120px 0 40px 0;
  ${mediaQueryMobile} {
    padding: 40px 0;
  }
`;

export const FaqContainer = styled(Flex)`
  justify-content: space-between;
  ${mediaQueryTablet} {
    flex-direction: column;
  }
`;

export const FaqTextWrapper = styled(Box)`
  width: 40%;
  margin-right: 24px;
  ${mediaQueryTablet} {
    width: 100%;
    margin-right: 0px;
  }
`;

export const FaqWrapper = styled(Box)`
  width: 60%;
  max-width: 728px;
  ${mediaQueryTablet} {
    width: 100%;
    max-width: none;
    margin-top: 24px;
  }
`;
